import { POISurroundInfo, POISurroundType } from "../../model/POISearch.js";
import { UCMapEvent } from "../UCMapJs.js";
import { DrawGeometry, DrawGeometryType } from "../../model/DrawGeometryJs.js";

import {TdtUser} from "../../model/TdtUserJs.js";

export class POISurroundOverLayJs {
  constructor() {

    this.id_li_surroundType_poi = "li_surroundType_poi";
    this.id_li_surroundType_routeStartPOI = "li_surroundType_routeStartPOI";
    this.id_li_surroundType_driveViaPOI = "li_surroundType_driveViaPOI";
    this.id_li_surroundType_driveEndPOI = "li_surroundType_driveEndPOI";
    this.id_poiType_school = "poiType_school";
    this.id_poiType_hospital = "poiType_hospital";
    this.id_poiType_busStation = "poiType_busStation";
    this.id_poiType_bank = "poiType_bank";
    this.id_i_addcollect = "id_i_addcollect";

    this.id_inputPOISearch = "inputPOISearch";
    this.id_spanPOISearch = "spanPOISearch";

    this.curPOI = null;

    /**
     * poi模糊查询关键字
     */
    this.poiFuzzyKey = null;

    /**
     * 周边搜索信息
     */
    this.surroundInfo = null;


    this.ucOverLay = null;

    this.ucFormCollectFolder = null;

  }

  init() {

    this.surroundInfo = new POISurroundInfo();
    this.surroundInfo.poi = this.curPOI;
    this.surroundInfo.surroundType = POISurroundType.type_POI;

    this.ucOverLay.curPOI = this.curPOI;
    this.ucOverLay.init();

    let drawItem=new DrawGeometry();
    drawItem.type=DrawGeometryType.point;
    drawItem.name=this.curPOI.name;
    drawItem.poi=this.curPOI;

    this.ucFormCollectFolder.tagObject=drawItem;

  }

  /**
   * 绑定事件
   */
  bindingEvents() {
    //绑定元素事件
    this._bindingDomElementEvents();
  }

  ucRenderFinished(callback) {
    let self = this;
    this.ucOverLay.$nextTick(function () {


      let innerHtml = self.ucOverLay.$el.innerHTML;
      if (callback) {
        callback(innerHtml);
      }
    });

  }
  


  on_getSurroundInfoFinished(callback) {
    if (callback) {
      this.ucOverLay.$on(
        UCMapEvent.POISurroundOverLay_getSurroundInfoFinished,
        callback
      );
    }
  }


  off_selectCollectFolderFinished(callback) {
    this.ucFormCollectFolder.off_selectFolderFinished(callback);
  }


  on_selectCollectFolderFinished(callback) {
    this.ucFormCollectFolder.on_selectFolderFinished(callback);
  }



  _bindingDomElementEvents() {
    let self = this;

    let eleSurroundType_poi = document.getElementById(this.id_li_surroundType_poi);
    eleSurroundType_poi.onclick = function (evt) {
      self._surroundTypeClickHandler(0);
    };

    let eleSurroundType_routeStartPOI = document.getElementById(this.id_li_surroundType_routeStartPOI);
    eleSurroundType_routeStartPOI.onclick = function (evt) {
      self._surroundTypeClickHandler(1);
    };

    let eleSurroundType_driveViaPOI = document.getElementById(this.id_li_surroundType_driveViaPOI);
    eleSurroundType_driveViaPOI.onclick = function (evt) {
      self._surroundTypeClickHandler(2);
    };

    let eleSurroundType_driveEndPOI = document.getElementById(this.id_li_surroundType_driveEndPOI);
    eleSurroundType_driveEndPOI.onclick = function (evt) {
      self._surroundTypeClickHandler(3);
    };


    let elePOIType_school = document.getElementById(this.id_poiType_school);
    elePOIType_school.onclick = function (evt) {

      let poiType = {};
      poiType.name = elePOIType_school.textContent;

      self._POITypeClickHandler(poiType);
    };


    let elePOIType_hospital = document.getElementById(this.id_poiType_hospital);
    elePOIType_hospital.onclick = function (evt) {

      let poiType = {};
      poiType.name = elePOIType_hospital.textContent;

      self._POITypeClickHandler(poiType);
    };


    let elePOIType_busStation = document.getElementById(this.id_poiType_busStation);
    elePOIType_busStation.onclick = function (evt) {
      let poiType = {};
      poiType.name = elePOIType_busStation.textContent;

      self._POITypeClickHandler(poiType);
    };

    let elePOIType_bank = document.getElementById(this.id_poiType_bank);
    elePOIType_bank.onclick = function (evt) {

      let poiType = {};
      poiType.name = elePOIType_bank.textContent;

      self._POITypeClickHandler(poiType);
    };

    let ele_inputPOISearch = document.getElementById(this.id_inputPOISearch);
    ele_inputPOISearch.onchange = function (evt) {

      self.poiFuzzyKey = ele_inputPOISearch.value;

    };


    let ele_spanPOISearch = document.getElementById(this.id_spanPOISearch);
    ele_spanPOISearch.onclick = function (evt) {
      self._poiSearchClickHandler();


    };

    let ele_addcollect = document.getElementById(this.id_i_addcollect);
    ele_addcollect.onclick = function (evt) {

      if(!TdtUser.currentUser)
      { 
        self.ucOverLay.$message({
          showClose: true,
          type: "info",
          message: "请先登录!"
        });

        return;
      }

      self._addCollectItem();
    }

  }


  _addCollectItem() {
    this.ucFormCollectFolder.init();
    this.ucFormCollectFolder.showForm();
  }


  _surroundTypeClickHandler(typeIndex) {

    if (typeIndex === 0) {
      this.surroundInfo.surroundType = POISurroundType.type_POI;
    } else if (typeIndex === 1) {
      this.surroundInfo.surroundType = POISurroundType.type_route_startPOI;
      this._emitGetSurroundInfoFinished();
    } else if (typeIndex === 2) {
      this.surroundInfo.surroundType = POISurroundType.type_route_viaPOI;
      this._emitGetSurroundInfoFinished();
    } else if (typeIndex === 3) {
      this.surroundInfo.surroundType = POISurroundType.type_route_endPOI;
      this._emitGetSurroundInfoFinished();
    }
  }

  _POITypeClickHandler(poiType) {
    if (!poiType) return;

    this.surroundInfo.surroundPOIFuzzyKey = poiType.name;

    this._emitGetSurroundInfoFinished();
  }

  _poiSearchClickHandler() {
    if (!this.poiFuzzyKey) return;

    this.surroundInfo.surroundPOIFuzzyKey = this.poiFuzzyKey;

    this._emitGetSurroundInfoFinished();
  }

  _emitGetSurroundInfoFinished() {
    this.ucOverLay.$emit(
      UCMapEvent.POISurroundOverLay_getSurroundInfoFinished,
      this.surroundInfo
    );
  }

}



export const POISurroundOverLayEvents =
{
    UCFormSelectCollectFolder_event_selectFolderFinished: "event_UCFormSelectCollectFolder_event_surroundSelectFolderFinished",


}